module.exports = __webpack_public_path__ + "img/subTitle.e8786fad.svg";